module.exports = __webpack_public_path__ + "static/media/mappa.747c2689.svg";